<template>
  <div class="app-container">
    <el-container>
      <el-main>
        <PaymentProfile :sid="type" />
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import PaymentProfile from './components/payment_profile/index.vue'

export default defineComponent({
  name: 'Verification',
  components: {
    PaymentProfile
  },
  props: {
    type: {
      type: String,
      required: true
    }
  }
})
</script>
